import { useEffect, useState } from 'react';
import {
    Box, makeStyles,
} from '@material-ui/core';
//Helpers
import { OPTIONS_DEVICES } from './helpers'
import { blueBar } from '../../helpers/common'
//Componentes
import ButtonComponent from "./ButtonComponent";
// //servicios 
import { putControlSetting } from '../../services/meters'
import { connectWebSocket } from '../../helpers/socketFunctions';
// import UserContext from '../../context/UserContext';

const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(0, 0, 1, 0),
        border: "0.5px solid #B6B1B1",
        borderRadius: "4px",
        padding: theme.spacing(1),
        width: "100%",

    },
    title: {
        fontSize: theme.spacing(1.9),
        fontWeight: '600',
        color: theme.palette.primary.main
    },
    subTitle: {
        color: theme.palette.grey.hairline,
        fontWeight: '400'
    }
}));


export default function PhaseControl({
    setLoading, setAlertState, options, dataPhases, selectedNode, selectedMeterAux, setLoadingInbox, setStateHelper
}) {
    const classes = useStyles();
    const blueLine = blueBar()
    const [dataMap, setDataMap] = useState([])
    // const [stateHelper, setStateHelper] = useState({
    //     status: false,
    //     result: 'error'
    // });

    // useEffect(() => {
    //     if (stateHelper.status === "completed") {
    //         setAlertState({
    //             close: true,
    //             msg: 'Su configuración fue exitosa',
    //             type: 'success'
    //         })
    //         setLoading(false)
    //         setLoadingInbox(false)
    //         return
    //     }
    //     if (stateHelper.status === "error") {
    //         setAlertState({
    //             close: true,
    //             msg: stateHelper?.message,
    //             type: "error"
    //         })
    //         setLoading(false)
    //         setLoadingInbox(false)
    //         return
    //     }
    //     if (stateHelper.status === "disconnected") {
    //         setLoading(false)
    //         setLoadingInbox(false)
    //     }
    // }, [stateHelper])

    useEffect(() => {
        if (options.plan === OPTIONS_DEVICES.SMART) {
            setDataMap(["R", "S", "T"])
        }
        if (options.plan === OPTIONS_DEVICES.HOME) {
            setDataMap(["R", "S"])
        }
        else {
            let elementAux = getEnabledKeys(selectedNode?.info_fases)
            setDataMap(elementAux)
        }
        // eslint-disable-next-line
    }, [selectedMeterAux])

    function getEnabledKeys(obj) {
        if (!obj || typeof obj !== "object") return [];
        return Object.keys(obj).filter(key => obj[key] === true);
    }

    const validatePhase = (phase) => {
        if (phase) {
            if (phase === 'R') {
                return 0
            }
            if (phase === 'S') {
                return 1
            }
            if (phase === 'T') {
                return 2
            }
        }
        else {
            return ''
        }
    }

    //Funcion q saca el guion del final del string
    function removeLastDashNumber(strAux) {
        let str = strAux
        if (!str) {
            str = selectedNode?.realtime?.llave
        }
        if (str.includes("-")) {
            return str.substring(0, str.lastIndexOf("-"));
        }
        return str;
    }

    function getLastPartAfterDash(str) {
        if (!str) {
            str = selectedNode?.realtime?.llave
        }
        if (str.includes("-")) {
            const lastPart = str.split("-").pop();
            return lastPart !== undefined ? Number(lastPart) : str;
        }
        return str;
    }

    //Envia la data para invertir fases.
    const HandleSubmit = async (element) => {
        setLoading(true)
        setLoadingInbox(true)
        try {
            let filterPhase = dataPhases.find(e => e.envio_id === element)
            if (options.plan === OPTIONS_DEVICES.SMART || options.plan === OPTIONS_DEVICES.HOME) {
                let auxBody = {
                    fase_id: filterPhase?.id,
                    key: "REVERSE_PHASE"
                }
                await putControlSetting(options?.id, auxBody)
                setAlertState({
                    close: true,
                    msg: "Exitoso",
                    type: "success"
                })
                setLoadingInbox(false)
                setLoading(false)
            }
            else {
                setLoadingInbox(true)
                let idAuxPhase = validatePhase(filterPhase?.envio_id)
                const message = {
                    value: {
                        mac: removeLastDashNumber(selectedNode?.realtime?.llave),
                        time: null,
                        device_type: selectedNode?.realtime?.producto,
                        action: "",
                        extra_info: { id: getLastPartAfterDash(selectedNode?.realtime?.llave), c: idAuxPhase }
                    },
                    type: "INVERT_PHASE",
                };
                connectWebSocket(message, setStateHelper);
            }
        }
        catch (error) {
            setAlertState({
                close: true,
                msg: "Ocurrio un error inesperado",
                type: "error"
            })
            setLoading(false)
            setLoadingInbox(false)
        }
    }

    return (
        <Box className={classes.root}>

            {/* titulo */}
            <Box ml={1} mt={2} mb={2} className={classes.title} >
                {"Control"}
                <span className={classes.subTitle} >
                    {` | ${"de fases"}`}
                </span>
            </Box>

            {blueLine}

            {/* Botones invertir fase */}
            <Box display='flex' justifyContent='center' flexDirection={"column"} alignItems={"center"}>
                {
                    dataMap.map((element, indx) => {
                        return (
                            < ButtonComponent
                                key={indx}
                                children={
                                    <>
                                        <Box  > {`invertir`}</Box>
                                        <Box ml={1} style={{ fontWeight: "bold" }}> {`Fase ${dataMap?.length === 1 ? '' : element}`}</Box>
                                    </>
                                }
                                HandleSubmit={() => { HandleSubmit(element) }}
                                backgroundColorButton={"primary"}
                            />

                        )
                    })
                }
            </Box>
        </Box>
    )
}






